import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import { DataFilterSubskrypcjeService } from 'src/app/services/data-filter-subskrypcje.service';
import {StatusSubskrypcji} from '../../models/status-subskrypcji.enum';
import { DestroyComponent } from '../destroy/destroy.component';
import { takeUntil } from 'rxjs/operators';
import { SubskrypcjeFiltr } from 'src/app/models/subskrypcje-filtr.model';

@Component({
  selector: 'app-subskrypcje-filtry',
  templateUrl: './subskrypcje-filtry.component.html',
  styleUrls: ['./subskrypcje-filtry.component.scss']
})
export class SubskrypcjeFiltryComponent extends DestroyComponent implements OnInit {

  constructor(
    private fb: FormBuilder,
    public dataFilterService: DataFilterSubskrypcjeService
  ) {
    super();
  }

  @Input() showSubsWithEvents: boolean;
  form: FormGroup;
  statusSub: StatusSubskrypcji;
  statusySubskrypcji = [StatusSubskrypcji.AKTYWNA, StatusSubskrypcji.ODWOLANA,
    StatusSubskrypcji.WYGASAJACA, StatusSubskrypcji.WYGASLA, StatusSubskrypcji.ZAMOWIONA];
  takNieLista = ['TAK', 'NIE'];
  subskrypcjaDoMin: Date = null;
  dataOstatniegoZdarzeniaDoMin: Date = null;
  togglePanelFiltry = false;

  ngOnInit(): void {
    this.initForm();
    this.showSubscriptionsWithNewEvents(this.showSubsWithEvents);
    this.initValidation();
  }

  initForm(): void {
    this.form = this.fb.group({
      subskrypcjaOd: [],
      subskrypcjaDo: [],
      dataOstatniegoZdarzeniaOd: [],
      dataOstatniegoZdarzeniaDo: [],
      noweZdarzenia: [],
      systemId: [''],
      status: [[]],
    });

    const value = this.dataFilterService.dataFilter.getValue();
    this.form.patchValue(value);
    // if(value?.type && value.type?.length === 1) {
    //   this.form.get('type').setValue(this.typZdarzenia.find(x => x.value[0] === +value.type[0]));
    // }
  }

  showSubscriptionsWithNewEvents(showSubsWithEvents: boolean): void{
    if (showSubsWithEvents) {
      this.form.get('status').setValue([StatusSubskrypcji.AKTYWNA, StatusSubskrypcji.WYGASAJACA]);
      this.form.get('noweZdarzenia').setValue('TAK');
      this.form.updateValueAndValidity();
      this.filter();
    }
  }

  filter(): void {
    this.dataFilterService.runFilter(SubskrypcjeFiltr.filtrKey, this.form.value);
  }

  clear(): void {
    this.form.reset();
    this.form.get('status').setValue([]);
    this.form.get('noweZdarzenia').setValue('');
    setTimeout(() => {
      // set form value noweZdarzenia
      this.form.get('noweZdarzenia').setValue(null);
      this.filter();
    }, 0 );
  }

  private initValidation() {
    this.form.get('subskrypcjaOd')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.subskrypcjaDoMin = new Date(value);
        const dataDo = new Date(this.form?.get('subskrypcjaDo').value);
        if(this.subskrypcjaDoMin.getTime() > dataDo.getTime()) {
          this.form?.get('subskrypcjaDo').setValue(null);
        }
      });

    this.form.get('dataOstatniegoZdarzeniaOd')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.dataOstatniegoZdarzeniaDoMin = new Date(value);
        const dataDo = new Date(this.form?.get('dataOstatniegoZdarzeniaDo').value);
        if(this.dataOstatniegoZdarzeniaDoMin.getTime() > dataDo.getTime()) {
          this.form?.get('dataOstatniegoZdarzeniaDo').setValue(null);
        }
      });
  }
}
